<!-- eslint-disable vue/html-self-closing -->
<!-- eslint-disable vue/no-use-v-if-with-v-for -->
<template>
  <div class="project-files-list col-lg-10 pb-4">
    <div class="project-files-list__head my-2">
      <ul class="project-files-list__file-path h6">
        <li class="project-files-list__file-path-item-head">
          <router-link
            class="f4"
            tag="a"
            :to="{
              name: 'project-files',
              query: {
                ...(commit ? { commit: commit } : {}),
                ...(branch && !commit ? { branch: branch } : {})
              }
            }"
            active-class=""
            exact-active-class=""
            exact
          >
            {{ projectAlias }}
          </router-link>
          <span class="project-files-list__path-divider f4">/</span>
        </li>
        <li
          v-for="(fileName, index) in filePath?.split('/')"
          v-if="filePath"
          :key="index"
          class="project-files-list__file-path-item"
        >
          <router-link
            v-if="index !== filePath?.split('/')?.length - 1"
            tag="a"
            :to="{
              name: 'project-files',
              query: {
                file: getFilePathByIndex(index),
                ...(commit ? { commit: commit } : {}),
                ...(branch && !commit ? { branch: branch } : {})
              }
            }"
            :class="{ active: isActiveLink(index) }"
            exact
          >
            {{ filePath.split('/')[index] }}
          </router-link>
          <span v-else>
            {{ filePath.split('/')[index] }}
          </span>
          <span
            v-if="$route?.name === 'project-files' || fileName !== filePath?.split('/')?.pop()"
            class="project-files-list__path-divider f4"
          >
            /
          </span>
        </li>
      </ul>
      <gf-custom-clipboard
        v-if="filePath"
        class="project-files-list__head-copy-path"
        :text-to-copy="filePath"
        :show-only-button="true"
      />
      <div
        class="project-files-list__head-edit-file"
        v-if="hasUserRole"
      >
        <gf-custom-tooltip
          v-if="$route?.name === 'project-files'"
          width="200px"
          class="d-inline-block"
          position="left"
        >
          <template #element>
            <gf-dropdown
              position="right"
              btn-class="btn btn-sm btn-success"
              :btn-text="$t('file.addFiles')"
              :disabled="!hasEditPermissions"
            >
              <router-link
                class="dropdown-item"
                tag="button"
                :to="{
                  name: 'project-file-create',
                  query: $route.query
                }"
                active-class=""
                exact-active-class=""
                exact
              >
                <i class="gf-icon gf-icon-plus mr-1"></i>
                {{ $t('file.createFile') }}
              </router-link>
              <button
                class="dropdown-item"
                type="button"
                @click="openUploadFilesModal"
              >
                <i class="gf-icon gf-icon-upload mr-1"></i>
                {{ $t('file.uploadFiles') }}
              </button>
            </gf-dropdown>
          </template>
          <template
            v-if="!hasEditPermissions"
            #content
          >
            <small>{{ cannotEditText }}</small>
          </template>
        </gf-custom-tooltip>
        <gf-clone-project-dropdown
          :alias="alias"
          :project-alias="projectAlias"
          :current-branch="branch"
        ></gf-clone-project-dropdown>
        <gf-custom-tooltip
          v-if="$route?.name === 'project-files' && this.filePath"
          width="200px"
          class="d-inline-block"
          position="left"
        >
          <template #element>
            <button
              class="btn btn-sm btn-danger"
              type="button"
              :disabled="!hasEditPermissions"
              @click="openDeleteDirectoryModal"
            >
              <i class="gf-icon gf-icon-trash"></i>
            </button>
          </template>
          <template
            v-if="!hasEditPermissions"
            #content
          >
            <small>{{ cannotEditText }}</small>
          </template>
        </gf-custom-tooltip>
      </div>
      <gf-custom-modal-window
        v-if="hasUserRole && hasEditPermissions"
        ref="gfCustomModalWindowDeleteDirectory"
        gf-modal-data-name="deleteDirectoryModal"
        :gf-modal-header="$t('directory.deleteQuestion')"
        gf-modal-wrapper-width="500px"
        @close="resetDeleteDirectoryErrors"
      >
        <template #body>
          <project-delete-directory-form
            :branch="branch"
            :directory-name="directoryName"
            @cancel="closeDeleteDirectoryModal"
            @submit="deleteDirectory"
          />
        </template>
      </gf-custom-modal-window>
      <gf-custom-modal-window
        v-if="hasUserRole && hasEditPermissions"
        ref="gfCustomModalWindowUploadFiles"
        gf-modal-data-name="uploadFilesModal"
        :gf-modal-header="$t('file.uploadFiles')"
        gf-modal-wrapper-width="500px"
        @close="resetUploadErrors"
      >
        <template #body>
          <project-upload-files-form
            ref="uploadFilesForm"
            :branch="branch"
            @cancel="closeUploadFilesModal"
            @submit="uploadFiles"
          />
        </template>
      </gf-custom-modal-window>
    </div>
    <div v-if="!hasError">
      <div
        v-if="lastCommit"
        class="project-files-list__last-commit"
      >
        <div class="project-files-list__last-commit-info">
          <div class="project-files-list__last-commit-info-user">
            <img
              class="mr-1 rounded-circle"
              height="25px"
              width="25px"
              :src="lastCommit.user ? lastCommit.user?.avatar : lastCommit.authorIdent?.avatar"
              loading="lazy"
            />
            <a
              v-if="lastCommit.user"
              :href="`/user/${lastCommit.user?.username}`"
              class="mr-2 text-dark font-weight-bolder text-truncate"
            >
              {{ lastCommit.user?.fullName }}
            </a>
            <a
              v-else
              :href="`mailto:${lastCommit.authorIdent?.emailAddress}`"
              class="mr-2 text-dark font-weight-bolder text-truncate"
            >
              {{ lastCommit.authorIdent?.name }}
            </a>
          </div>
          <a
            class="w-100 text-muted text-truncate"
            :href="`/project/${alias}/${projectAlias}/commit/${lastCommit.hash}`"
          >
            {{ lastCommit.shortMessage }}
          </a>
        </div>
        <div class="project-files-list__last-commit-history">
          <span class="text-muted mr-3">{{ $moment(lastCommit?.createdAt).fromNow() }}</span>
          <a
            class="d-flex align-items-center text-dark"
            :href="`/project/${alias}/${projectAlias}/commit?branch=${branch}`"
          >
            <i class="gf-icon gf-icon-history mr-1" />
            <span class="d-none d-lg-inline-block">{{ $t('message.history') }}</span>
          </a>
        </div>
      </div>
      <gf-custom-alert
        v-if="blobBlame?.ignoredRevs === true"
        variant="primary"
        element-class="mb-3"
      >
        <template #body>
          <span>{{ $t('blame.revs.ignoring') }}</span>
          <router-link
            tag="a"
            :to="{
              name: 'project-file-blob',
              query: {
                file: '.git-blame-ignore-revs',
                ...(commit ? { commit: commit } : {}),
                ...(branch && !commit ? { branch: branch } : {})
              }
            }"
            active-class=""
            exact-active-class=""
            exact
          >
            .git-blame-ignore-revs
          </router-link>
        </template>
      </gf-custom-alert>
      <div v-if="$route?.name === 'project-files' && files?.length > 0">
        <div class="project-files-list__item-header">
          <div
            class="project-files-list__cell"
            data-cell-type="filename"
          >
            {{ $t('file.fileName') }}
          </div>
          <div
            class="project-files-list__cell"
            data-cell-type="commit"
          >
            {{ $t('commit.lastCommit') }}
          </div>
          <div
            class="project-files-list__cell"
            data-cell-type="date"
          >
            {{ $t('commit.time') }}
          </div>
        </div>
        <gf-files-list
          :files="files"
          :commits="commits"
        />
        <div
          v-if="readmeInFolderInfo && folderReadme"
          class="project-files-list__readme mt-3"
        >
          <div class="project-files-list__readme-header">
            <span class="d-flex align-items-center">
              <i class="gf-icon gf-icon-file mr-1"></i>
              <span class="text-dark">{{ readmeInFolderInfo?.filename }}</span>
            </span>
          </div>
          <div
            class="project-files-list__readme-content p-3 markdown-body"
            v-html="folderReadme"
          ></div>
        </div>
      </div>
      <div
        v-else-if="$route?.name === 'project-files' && files?.length === 0"
        class="project-files-list__files-none py-2 px-3"
      >
        <div>{{ $t('file.noFiles') }}</div>
      </div>
      <gf-file-blob
        v-else-if="
          $route?.name === 'project-file-blob' &&
          lastCommitBranch &&
          Object.keys(lastCommitBranch)?.length > 0
        "
        :alias="alias"
        :project-alias="projectAlias"
        :commit-hash="lastCommitBranch?.hash"
        :blob="blob"
        :blame="blobBlame"
        :markdown-preview="blobMarkdownPreview"
        :has-edit-permissions="hasEditPermissions"
        :has-user-role="hasUserRole"
        :file-path="this.filePath"
        @markdown="getMarkdownPreview"
        @blame="getBlobBlame"
      />
    </div>
    <div
      v-else
      class="project-files-list__not-found"
    >
      <h4>404</h4>
      <h6>{{ $t('message.page_not_found') }}</h6>
      <router-link
        class="mt-1 btn btn-dark btn-sm"
        tag="button"
        :to="{
          name: 'project-files',
          query: {
            ...(branch ? { branch: branch } : {}, commit ? { commit: commit } : {})
          }
        }"
        active-class=""
        exact-active-class=""
        exact
      >
        {{ $t('file.returnToRepositoryRoot') }}
      </router-link>
    </div>
  </div>
</template>

<script>
import RepoS from '@shared/services/repository.service';
import GfFilesList from '@/shared-modules/shared-components/shared/GfFilesList';
import GfCustomClipboard from '@/shared-modules/shared-components/shared/GfCustomClipboard';
import GfFileBlob from '@/shared-modules/shared-components/shared/GfFileBlob';
import GfCustomAlert from '@/shared-modules/shared-components/shared/GfCustomAlert';
import projectFilesMessages from '@/shared-modules/modules/project-files/project-files.messages';
import GfDropdown from '@/shared-modules/shared-components/shared/GfDropdown';
import { FORM_NAME_ENUMS } from '@/shared-modules/variables/form-name.enums';
// eslint-disable-next-line max-len
import ProjectUploadFilesForm from '@/shared-modules/modules/project-files/components/project-upload-files-form';
import GfCustomTooltip from '@/shared-modules/shared-components/shared/GfCustomTooltip';
import projectDeleteDirectoryForm from './project-delete-directory-form.vue';
import qs from 'qs';
import { messageNotification } from '@shared/services/gf.notification.service';
import GfCloneProjectDropdown from '@shared/shared-components/shared/GfCloneProjectDropdown';

export default {
  name: 'ProjectFilesList',
  components: {
    GfFilesList,
    GfCustomClipboard,
    GfFileBlob,
    GfCustomAlert,
    GfDropdown,
    ProjectUploadFilesForm,
    GfCustomTooltip,
    projectDeleteDirectoryForm,
    GfCloneProjectDropdown
  },
  data() {
    return {
      lastCommitBranch: null,
      lastCommit: null,
      hasError: false,
      blob: {},
      blobMarkdownPreview: null,
      blobBlame: null,
      folderReadme: null
    };
  },
  computed: {
    branch() {
      return this.$route?.query?.branch || document.getElementById('currentBranch')?.value;
    },
    commit() {
      return this.$route?.query?.commit;
    },
    alias() {
      return this.$route?.params?.alias;
    },
    projectAlias() {
      return this.$route?.params?.projectAlias;
    },
    filePath() {
      return this.$route?.query?.file;
    },
    files() {
      return this.$store.getters.getNodeChildrenByPath(this.filePath || '');
    },
    commits() {
      return this.$store.getters.getCommitInfoByPath(this.filePath || '');
    },
    getParentFilePath() {
      return this.filePath?.substring(0, this.filePath.lastIndexOf('/')) || '';
    },
    readmeInFolderInfo() {
      const readmeMd = this.files?.find((file) => file.filename.toLowerCase() === 'readme.md');
      if (readmeMd) {
        return readmeMd;
      }
      return this.files?.find((file) => file.filename.toLowerCase() === 'readme.txt');
    },
    storedBlob() {
      return this.$store.getters.getBlobByPath(this.filePath);
    },
    storedMarkdownPreview() {
      return this.$store.getters.getMarkdownPreviewByPath(this.filePath);
    },
    storedFolderReadme() {
      return this.$store.getters.getMarkdownPreviewByPath(this.readmeInFolderInfo?.path);
    },
    storedBlame() {
      return this.$store.getters.getBlameByPath(this.filePath);
    },
    branchPermissions() {
      return (
        this.$store.getters.getBranchPermissionByBranch(this.branch) || this.getBranchPermissions()
      );
    },
    hasUserRole() {
      return this.branchPermissions?.IS_USER_IN_PROJECT || false;
    },
    hasEditPermissions() {
      if (this.$route.query.commit) return false;
      return this.branchPermissions?.ALLOW_TO_PUSH;
    },
    cannotEditText() {
      return this.$route.query.commit
        ? this.$t('file.switchToBranchToAddFiles')
        : this.$t('file.notEnoughPermissionsToAddFiles');
    },
    directoryName() {
      return this.filePath?.split('/').pop() || '';
    },
    // последний коммит в текущую директорию
    lastCommitInFolder() {
      return this.$store.getters.getLastCommitInNodes(this.filePath) || this.lastCommitBranch;
    }
  },
  watch: {
    $route() {
      if (
        !this.commits &&
        this.$route?.name === 'project-files' &&
        this.lastCommitBranch &&
        Object.keys(this.lastCommitBranch)?.length > 0
      ) {
        this.getCommits();
      } else if (this.$route?.name === 'project-files') {
        this.lastCommit = this.lastCommitInFolder;
      }
    },
    '$route.query.file': function () {
      this.folderReadme = null;
      if (this.$route?.name === 'project-file-blob') {
        this.blob = {};
        this.blobMarkdownPreview = null;
        this.blobBlame = null;
        this.getBlob();
      }
    },
    files() {
      if (this.readmeInFolderInfo && this.lastCommitBranch) this.getFolderReadme();
    },
    lastCommitBranch() {
      if (this.readmeInFolderInfo && this.lastCommitBranch) this.getFolderReadme();
    }
  },
  mounted() {
    if (this.commit) {
      RepoS.getCommitInfo(this.alias, this.projectAlias, this.commit).then(
        (res) => {
          this.lastCommitBranch = res;
          if (this.$route?.name === 'project-file-blob') this.getBlob();
          else if (!this.commits) this.getCommits();
        }
      )
    } else {
      RepoS.getLastBranchCommit(this.alias, this.projectAlias, { branchName: this.branch }).then(
        (res) => {
          this.lastCommitBranch = res;
          if (this.$route?.name === 'project-file-blob') this.getBlob();
          else if (!this.commits) this.getCommits();
        }
      );
    }
  },
  methods: {
    getCommits() {
      RepoS.getRepositoryFilesCommits(
        this.alias,
        this.projectAlias,
        this.alias,
        this.lastCommitBranch.hash,
        {
          filePath: encodeURIComponent(this.filePath == null ? '' : this.filePath)
        }
      )
        .then(() => {
          this.hasError = false;
          this.lastCommit = this.lastCommitInFolder;
        })
        .catch(() => {
          this.hasError = true;
        });
    },
    // Комплексный метод для получения и коммитов, и вызова метода для самого блоба.
    // Для получения последнего коммита в блоб используется запрос last-for-files в родительскую папку.
    getBlob() {
      const path = encodeURIComponent(this.getParentFilePath == null ? '' : this.getParentFilePath);
      if (!this.getCommitsByPath(path)) {
        RepoS.getRepositoryFilesCommits(
          this.alias,
          this.projectAlias,
          this.alias,
          this.lastCommitBranch?.hash,
          {
            filePath: path
          }
        )
          .then((res) => {
            this.lastCommit = this.getBlobCommit(res, this.filePath?.split('/')?.pop());
            this.getFileBlob(this.lastCommit.hash);
            this.hasError = false;
          })
          .catch(() => {
            this.hasError = true;
          });
      } else {
        this.lastCommit = this.getBlobCommit(
          this.getCommitsByPath(path),
          this.filePath?.split('/')?.pop()
        );
        this.getFileBlob(this.lastCommit.hash);
      }
    },
    getFolderReadme() {
      if (this.storedFolderReadme) {
        this.folderReadme = this.storedFolderReadme;
      } else {
        RepoS.getFileMarkdown(this.alias, this.projectAlias, {
          file: encodeURIComponent(this.readmeInFolderInfo?.path),
          branch: this.branch,
          commit: this.lastCommitBranch?.hash
        }).then((res) => {
          this.folderReadme = res;
        });
      }
    },
    // Метод получения блоба
    getFileBlob() {
      if (this.storedBlob) {
        this.blob = this.storedBlob;
        this.hasError = false;
      } else {
        RepoS.getFileBlob(this.alias, this.projectAlias, {
          file: encodeURIComponent(this.filePath),
          branch: this.branch,
          commit: this.lastCommitBranch?.hash
        })
          .then((res) => {
            this.blob = res;
            this.hasError = false;
          })
          .catch(() => {
            this.hasError = true;
          });
      }
    },
    // Получение markdown-верстки
    getMarkdownPreview() {
      if (this.storedMarkdownPreview) {
        this.blobMarkdownPreview = this.storedMarkdownPreview;
      } else {
        RepoS.getFileMarkdown(this.alias, this.projectAlias, {
          file: encodeURIComponent(this.filePath),
          branch: this.branch,
          commit: this.lastCommitBranch?.hash
        }).then((res) => {
          this.blobMarkdownPreview = res;
        });
      }
    },
    getBlobBlame() {
      if (this.storedBlame) {
        this.blobBlame = this.storedBlame;
      } else {
        RepoS.getBlobBlame(this.alias, this.projectAlias, {
          file: encodeURIComponent(this.filePath),
          branch: this.branch,
          commit: this.lastCommitBranch?.hash
        }).then((res) => {
          this.blobBlame = res;
        });
      }
    },
    // Получение самого последнего коммита из списка коммитов при выводе файлов
    // getLastCommit() {
    //   let result = this.lastCommitBranch;
    //   if (this.commits && Object.keys(this.commits)?.length > 0) {
    //     result = Object.values(this.commits)
    //       .filter((obj) => obj.createdAt)
    //       .reduce((acc, curr) => {
    //         const accDate = new Date(acc.createdAt || 0);
    //         const currDate = new Date(curr.createdAt);
    //         return currDate > accDate ? curr : acc;
    //       }, {});
    //   }
    //   store.dispatch('addLastCommitInNodes', {
    //     nodePath: this.getParentFilePath,
    //     commitInfo: result
    //   });
    //   return result;
    // },
    getBranchPermissions() {
      RepoS.getBlobAndBranchPermissions(this.alias, this.projectAlias, {
        file: encodeURIComponent(this.filePath == null ? '' : this.filePath),
        branch: this.branch,
        commit: this.lastCommitBranch?.hash
      })
        .then((res) => res)
        .catch((err) => {
          console.error(err);
        });
    },
    // Получение коммитов из стора по выбранному пути
    getCommitsByPath(path) {
      return this.$store.getters.getCommitInfoByPath(path);
    },
    // Получение пути до файла по его fileName, используется для создания ссылок в навигации сверху
    getFilePathByIndex(index) {
      const pathParts = this.filePath.split('/');
      const slicedPath = pathParts.slice(0, index + 1);
      return slicedPath.join('/');
    },
    isActiveLink(index) {
      const fullPath = this.getFilePathByIndex(index); // Получаем полный путь до текущего элемента (игнорируя название файла)
      return this.$route.query.file === fullPath; // Сравниваем с текущим активным маршрутом
    },
    // Возвращает информацию о коммите в конкретный блоб из списка коммитов в родительской папке.
    getBlobCommit(commits, blobName) {
      return commits[blobName];
    },
    openUploadFilesModal() {
      this.$refs.gfCustomModalWindowUploadFiles.openModalWindow();
    },
    closeUploadFilesModal() {
      this.$refs.gfCustomModalWindowUploadFiles.closeModalWindow();
      this.resetUploadErrors();
    },
    uploadFiles(data) {
      if (!data?.filesData?.isMaxSizeExceeded) {
        const formData = new FormData();
        data?.filesData?.files?.forEach((file) => {
          formData.append('files', file);
        });
        formData.append('commitHash', this.lastCommitBranch?.hash);
        formData.append('sourceBranch', this.branch);
        formData.append('targetBranch', data.isDirectCommit ? this.branch : data.newBranchName);
        formData.append('commitMessage', data.message);
        formData.append('filesPath', this.filePath || '');
        formData.append('projectAlias', this.projectAlias);
        formData.append('ownerAlias', this.alias);
        RepoS.uploadFiles(this.alias, this.projectAlias, formData)
          .then((newData) => {
            const encodedParams = qs
              .stringify({
                file: newData?.filesPath,
                branch: newData?.targetBranch
              })
              .replace(/%25/g, '%');
            window.location.href = `/project/${this.alias}/${this.projectAlias}/file?${encodedParams}`;
          })
          .catch((err) => {
            if (err?.response?.data?.status === 403) {
              this.closeUploadFilesModal();
              messageNotification('danger', {
                message: err.response.data.detail,
                hasTimer: false
              });
            }
          });
      }
    },
    openDeleteDirectoryModal() {
      this.$refs.gfCustomModalWindowDeleteDirectory.openModalWindow();
    },
    closeDeleteDirectoryModal() {
      this.$refs.gfCustomModalWindowDeleteDirectory.closeModalWindow();
      this.resetDeleteDirectoryErrors();
    },
    deleteDirectory(data) {
      RepoS.deleteDirectory(this.alias, this.projectAlias, {
        commitHash: this.lastCommitBranch?.hash,
        commitMessage: data.message,
        sourceBranch: this.branch,
        targetBranch: data.isDirectCommit ? this.branch : data.newBranchName,
        directoryPath: this.filePath,
        projectAlias: this.projectAlias,
        ownerAlias: this.alias
      })
        .then((newData) => {
          const encodedParams = qs.stringify({
            file: newData?.redirectUrl,
            branch: newData?.params?.branchName
          });
          window.location.href = `/project/${this.alias}/${this.projectAlias}/file?${encodedParams}`;
        })
        .catch((err) => {
          if (err?.response?.data?.status === 403) {
            this.closeDeleteDirectoryModal();
            messageNotification('danger', {
              message: err.response.data.detail,
              hasTimer: false
            });
          }
        });
    },
    resetUploadErrors() {
      this.$refs.uploadFilesForm.resetFiles();
      this.$store.dispatch('setFormErrors', {
        formName: FORM_NAME_ENUMS.UPLOAD_FILES_FORM,
        errorResponse: null
      });
    },
    resetDeleteDirectoryErrors() {
      this.$store.dispatch('setFormErrors', {
        formName: FORM_NAME_ENUMS.DELETE_DIRECTORY_FORM,
        errorResponse: null
      });
    }
  },
  i18n: { messages: projectFilesMessages }
};
</script>

<style lang="scss">
$this: '.project-files-list';

#{$this} {
  @media screen and (max-width: 992px) {
    height: calc(100% - 30px);
  }

  #{$this}__head {
    min-height: 29px;
    display: flex;
    align-items: center;
    gap: 4px;

    @media screen and (max-width: 992px) {
      flex-direction: column;
      align-items: flex-start;
    }

    &-edit-file {
      margin-left: auto;
      display: flex;
      gap: 6px;

      @media screen and (max-width: 992px) {
        margin-left: 0;
      }
    }

    &-copy-path {
      width: 30px;
      display: inline-block;
    }
  }
  #{$this}__file-path {
    display: flex;
    padding: 0;
    margin: 0 5px 0 0;
    list-style: none;
    flex-wrap: wrap;
  }
  #{$this}__file-path-item-head {
    display: flex;
    font-weight: 550;
    letter-spacing: 0.015rem;
    word-break: break-word;
  }
  #{$this}__file-path-item {
    display: flex;
    font-weight: normal;
    word-break: break-word;
  }
  #{$this}__path-divider {
    display: flex;
    margin: 0 2px;
    color: var(--text-muted);
    font-weight: normal;
  }
  #{$this}__last-commit {
    padding: 8px 12px;
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    border: 1px solid var(--border-color);
    border-radius: var(--border-radius);
    white-space: nowrap;

    @media screen and (max-width: 992px) {
      gap: 12px;
      flex-direction: column-reverse;
    }

    &-info {
      width: 100%;
      display: flex;
      flex: 0 0 60%;
      overflow: hidden;
      align-items: center;
      gap: 4px;

      @media screen and (max-width: 992px) {
        flex: 0 0 100%;
        flex-direction: column;
        align-items: flex-start;
      }

      &-user {
        max-width: 40%;
        display: flex;
        align-items: center;

        @media screen and (max-width: 992px) {
          max-width: 100%;
        }
      }
    }
    &-history {
      width: 100%;
      display: flex;
      flex: 0 0 40%;
      align-items: center;
      justify-content: flex-end;

      @media screen and (max-width: 992px) {
        flex: 0 0 100%;
        justify-content: space-between;
      }
    }
  }
  #{$this}__files-none {
    background-color: var(--light);
    text-align: center;
    border: 1px solid var(--border-color);
    border-radius: var(--border-radius);
  }
  #{$this}__not-found {
    display: flex;
    flex-direction: column;
    padding: 12px 16px;
    align-items: center;
    border: 1px solid var(--border-color);
    border-radius: var(--border-radius);
  }
  #{$this}__readme {
    border: 1px solid var(--border-color);
    border-radius: var(--border-radius);

    &-header {
      padding: 6px 12px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: var(--text-muted);
      background-color: var(--light);
      border-bottom: 1px solid var(--border-color);
    }
  }
}

#{$this}__item-header {
  position: sticky;
  top: 0;
  padding: 7px;
  display: flex;
  background-color: var(--light);
  color: var(--text-muted);
  font-size: 13px;
  border: 1px solid var(--border-color);
  border-radius: var(--border-radius) var(--border-radius) 0 0;

  & div {
    padding: 0 5px;
    display: flex;
    align-items: baseline;
    overflow: hidden;
    font-weight: 550;
    letter-spacing: 0.015rem;
  }

  & div[data-cell-type='filename'] {
    flex: 0 0 35%;

    @media screen and (max-width: 543px) {
      flex: 0 0 50%;
    }
  }
  & div[data-cell-type='commit'] {
    flex: 0 0 40%;
    color: var(--text-muted);

    @media screen and (max-width: 543px) {
      display: none;
    }
  }
  & div[data-cell-type='date'] {
    flex: 0 0 25%;
    justify-content: flex-end;
    color: var(--text-muted);

    @media screen and (max-width: 543px) {
      flex: 0 0 50%;
    }
  }
}
</style>
